<template>
  <svg
    width="100%"
    height="100%"
  >
    <NodeLink
      v-for="line in lines"
      :key="line.id"
      :line="line"
      @editNodeLinks="editNode($event, line)"
    />
  </svg>
</template>

<script>
import { getConnectionPos } from '../../helpers/callFlow';
import { nodeLinkStyles } from '../../helpers/constants';
import { validateLinkCriterias } from '../../helpers/validation';

import NodeLink from './NodeLink';

export default {
  name: 'CallFlowLinks',
  components: {
    NodeLink,
  },
  props: {
    links: {
      type: Array,
      default() {
        return [];
      },
    },
    tempLink: {
      type: Object,
      default() {
        return {};
      },
    },
    nodes: {
      type: Array,
      default() {
        return [];
      },
    },

    /**
     * @type {import('vue').PropType<import('../../ivr').SceneContainer>}
     */
    container: {
      type: Object,
      default() {
        return {};
      },
    },

    /**
     * @type {import('vue').PropType<Object.<string, import('../../ivr').NodeLinkDetails>>}
     */
    nodeLinkDetails: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    lines() {
      const lines = [];
      this.links.forEach((link) => {
        const originNode = this.nodeLinkDetails[link.originNode.id];
        const targetNode = this.nodeLinkDetails[link.targetNode.id];
        const linkValidationErrors = validateLinkCriterias(link);

        if (!originNode || !targetNode) {
          return [];
        }

        const originLinkPos = getConnectionPos(
          originNode,
          link.originSlot,
          false,
          this.container
        );
        const targetLinkPos = getConnectionPos(
          targetNode,
          link.targetSlot,
          true,
          this.container
        );

        const x1 = originLinkPos.x;
        const y1 = originLinkPos.y;
        const x2 = targetLinkPos.x;
        const y2 = targetLinkPos.y;
        lines.push({
          id: link.id,
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          style: {
            stroke: link.targetNode.nodeOptions.accentColor,
            strokeWidth: nodeLinkStyles.strokeWidth * this.container.scale,
            fill: nodeLinkStyles.fillColor,
          },
          criteria: link.criteria,
          originNode: originNode,
          isValid: linkValidationErrors.isSuccessful,
          filter: link.filter,
          name: link.name,
        });
      });
      if (this.tempLink) {
        this.tempLink.style = {
          stroke: nodeLinkStyles.defaultStrokeColor,
          strokeWidth: nodeLinkStyles.strokeWidth * this.container.scale,
          fill: nodeLinkStyles.fillColor,
        };
        lines.push(this.tempLink);
      }
      lines.push(...this.getGoToLines());

      return lines;
    },
  },
  methods: {
    editNode(node, link) {
      this.$emit('editNodeLinks', {node, link});
    },
    getGoToLines() {
      const goToNodes = this.nodes.filter(
        (node) => node.nodeTypeId == 'GoToNode'
      );
      const lines = [];
      for (const originNode of goToNodes) {
        if (originNode.settings && originNode.settings.goToNodeId) {
          const originNodeLinkDetails = this.nodeLinkDetails[originNode.id];
          const targetNode = this.nodeLinkDetails[originNode.settings.goToNodeId];

          if (!originNodeLinkDetails || !targetNode) {
            return [];
          }

          const originLinkPos = getConnectionPos(
            originNodeLinkDetails,
            1,
            false,
            this.container
          );
          
          const targetLinkPos = getConnectionPos(
            targetNode,
            0,
            true,
            this.container
          );

          const x1 = originLinkPos.x;
          const y1 = originLinkPos.y;
          const x2 = targetLinkPos.x;
          const y2 = targetLinkPos.y;
          lines.push({
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            style: {
              stroke: 'white',
              strokeWidth: (nodeLinkStyles.strokeWidth * this.container.scale)/1.5,
              fill: 'none',
              'stroke-dasharray': 12
            },
            originNode: originNodeLinkDetails
          });
        }
      }
      return lines;
    },
  },
};
</script>